// Whether this browser can play a word's audio — split from audioUrl.ts so
// it has no Supabase import (the study store and its tests use it).

const PRIVATE_PREFIX = 'private:';

// Ogg/Opus clips (Anki decks often carry them) don't play in Safari / on
// iOS. Mirror of Flutter's `canPlayAudio` (lib/utils/audio_url.dart): such a
// clip is never offered where it can't play — no silent play button, no
// dictation built on it. Detected by asking the browser, not by user agent.
const OGG_EXT = /\.(ogg|oga|opus)$/i;

/** An Ogg/Opus file name or audio path. */
export const isOggAudio = (name: string | undefined | null): boolean => !!name && OGG_EXT.test(name);

let opusSupport: boolean | undefined;

/** Whether this browser plays Ogg/Opus. Without an Audio element (tests,
 *  server) it is assumed to — the old behaviour. */
export function browserPlaysOgg(): boolean {
  if (opusSupport === undefined) {
    try {
      opusSupport = typeof Audio === 'undefined' || new Audio().canPlayType('audio/ogg; codecs=opus') !== '';
    } catch {
      opusSupport = true;
    }
  }
  return opusSupport;
}

/** Tests only: pretend the browser does / doesn't play Ogg (undefined = ask). */
export function setOggSupportForTests(v: boolean | undefined): void {
  opusSupport = v;
}

/** A clip file this browser can't play (Ogg/Opus where unsupported). */
export const unplayableHere = (name: string | undefined | null): boolean => isOggAudio(name) && !browserPlaysOgg();

/** Whether this device can play [audioPath] at all. Gates "Hear it",
 *  dictation and every play button, so a card never offers silent audio.
 *  Dictionary audio is always mp3; only private uploads can be Ogg. */
export function canPlayAudio(audioPath: string | undefined | null): boolean {
  if (!audioPath) return false;
  if (!audioPath.startsWith(PRIVATE_PREFIX)) return true;
  return !unplayableHere(audioPath);
}

